import { Component, Input } from '@angular/core';
import { Collaborator } from '@core/typings/collaboration.typing';
import { OrganizationForInfoPanel } from '@core/typings/organization.typing';

@Component({
  selector: 'gc-applicant-org-details-block',
  templateUrl: './applicant-org-details-block.component.html',
  styleUrls: ['./applicant-org-details-block.component.scss']
})
export class ApplicantOrgDetailsBlockComponent {
  @Input() organization: OrganizationForInfoPanel;
  @Input() applicant: Collaborator;
  @Input() isMasked: boolean;
}
